import { render, staticRenderFns } from "./Rejected.vue?vue&type=template&id=1add9fa8&scoped=true&"
import script from "./Rejected.vue?vue&type=script&lang=js&"
export * from "./Rejected.vue?vue&type=script&lang=js&"
import style0 from "./Rejected.vue?vue&type=style&index=0&id=1add9fa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1add9fa8",
  null
  
)

export default component.exports